import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/smiley-cool.svg")